import { useLocation } from 'react-router-dom';

import { SidebarItem } from './components';

import { Sections } from 'types/global';

export const useMenu = (variant: Sections, isMobile: boolean) => {
  const location = useLocation();

  if (variant === 'instagram') {
    return (
      <nav className="p-2">
        <SidebarItem variant={variant} href="/instagram" active={location.pathname === '/instagram'}>
          Главная
        </SidebarItem>

        <SidebarItem
          href="/instagram/orders"
          variant={variant}
          active={location.pathname === '/instagram/orders' || location.pathname?.startsWith('/instagram/orders/')}
        >
          Заказы
        </SidebarItem>

        <SidebarItem
          variant={variant}
          href="/instagram/bloggers"
          active={location.pathname === '/instagram/bloggers' || location.pathname?.startsWith('/instagram/bloggers/')}
        >
          Блогеры
        </SidebarItem>

        <SidebarItem
          variant={variant}
          href="/instagram/clients"
          active={location.pathname === '/instagram/clients' || location.pathname?.startsWith('/instagram/clients/')}
        >
          Клиенты
        </SidebarItem>
      </nav>
    );
  }

  if (variant === 'telegram') {
    return isMobile ? (
      <nav className="p-2">
        <SidebarItem variant={variant} href="/" active={location.pathname === '/'}>
          Для рекламы
        </SidebarItem>

        <SidebarItem
          href="/orders"
          variant={variant}
          active={location.pathname === '/orders' || location.pathname?.startsWith('/orders/')}
        >
          Заказы
        </SidebarItem>

        <SidebarItem
          href="/channels"
          variant={variant}
          active={location.pathname === '/channels' || location.pathname?.startsWith('/channels/')}
        >
          Каналы
        </SidebarItem>

        <SidebarItem
          href="/pricing"
          variant={variant}
          active={location.pathname === '/pricing' || location.pathname?.startsWith('/pricing/')}
        >
          Цены канала
        </SidebarItem>

        <SidebarItem
          href="/dictionary"
          variant={variant}
          active={location.pathname === '/dictionary' || location.pathname?.startsWith('/dictionary/')}
        >
          Словарь
        </SidebarItem>

        <SidebarItem
          href="/clients"
          variant={variant}
          active={location.pathname === '/clients' || location.pathname?.startsWith('/clients/')}
        >
          Клиенты
        </SidebarItem>

        <SidebarItem
          href="/"
          variant={variant}
          isBlank
          active={location.pathname === '/' || location.pathname?.startsWith('/')}
        >
          Десктопная версия
        </SidebarItem>
      </nav>
    ) : (
      <nav className="p-2">
        <SidebarItem href="/" variant={variant} active={location.pathname === '/'}>
          Для рекламы
        </SidebarItem>

        <SidebarItem
          href="/orders"
          variant={variant}
          active={location.pathname === '/orders' || location.pathname?.startsWith('/orders/')}
        >
          Заказы
        </SidebarItem>

        <SidebarItem
          href="/channels"
          variant={variant}
          active={location.pathname === '/channels' || location.pathname?.startsWith('/channels/')}
        >
          Каналы
        </SidebarItem>

        <SidebarItem
          href="/pricing"
          variant={variant}
          active={location.pathname === '/pricing' || location.pathname?.startsWith('/pricing/')}
        >
          Цены канала
        </SidebarItem>

        <SidebarItem
          href="/dictionary"
          variant={variant}
          active={location.pathname === '/dictionary' || location.pathname?.startsWith('/dictionary/')}
        >
          Словарь
        </SidebarItem>

        <SidebarItem
          href="/clients"
          variant={variant}
          active={location.pathname === '/clients' || location.pathname?.startsWith('/clients/')}
        >
          Клиенты
        </SidebarItem>

        <SidebarItem
          href="/reports"
          variant={variant}
          active={location.pathname === '/reports' || location.pathname?.startsWith('/reports/')}
          subItems={[
            { href: '/reports/margin', label: 'Отчёт по марже' },
            { href: '/reports/accounting', label: 'Отчет для бухгалтерии' },
            { href: '/reports/channels', label: 'Статистика каналов' },
            { href: '/reports/buyers', label: 'Отчет по баерам' },
            { href: '/reports/pricing', label: 'Расчёт цен' },
          ]}
        >
          Отчёты
        </SidebarItem>

        <SidebarItem
          href="/admin"
          variant={variant}
          active={location.pathname === '/admin' || location.pathname?.startsWith('/admin/')}
          subItems={[
            { href: '/admin/payments', label: 'Подтверждения платежей' },
            { href: '/admin/roles', label: 'Управление ролями' },
            { href: '/admin/schedule', label: 'Время размещения' },
          ]}
        >
          Администрирование
        </SidebarItem>
      </nav>
    );
  }
};
